import { ITabsLayout, LayoutType } from '@components/layout';
import { MAIN_THEME } from '@styles';

export function getBusinessPartnerTabs(partnerType: string): ITabsLayout {
  const isReinsurer = partnerType === 'Reinsurer';

  return {
    typeLogicalId: LayoutType.tabslayout,
    leftColumn: {
      backgroundColor: MAIN_THEME.color.white,
      collapsable: false,
      width: 2,
      collapsed: false,
    },
    mainColumn: {
      backgroundColor: MAIN_THEME.color.white98,
      collapsable: false,
      width: 10,
      collapsed: false,
    },
    rightColumn: {
      backgroundColor: MAIN_THEME.color.white,
      collapsable: false,
      width: 0,
      collapsed: false,
    },
    tabs: [
      {
        name: 'summary',
        title: 'Summary',
        iconUrl: '/icons/file-summary-primary.svg',
        widgets: [{}],
      },
      {
        name: 'commissions&Limits',
        title: 'Commissions & Limits',
        iconUrl: '/icons/file-summary-primary.svg',
        widgets: [{}],
        hidden: isReinsurer,
      },
      {
        name: 'vignetteRange',
        title: 'Vignette Range',
        iconUrl: '/icons/folder-primary.svg',
        widgets: [{}],
        hidden: isReinsurer,
      },
      {
        name: 'paymentTerms',
        title: 'Payment Terms',
        iconUrl: '/icons/file-summary-primary.svg',
        widgets: [{}],
      },
    ],
  };
}
